import { render } from "./Legend.vue?vue&type=template&id=fb296248&scoped=true"
import script from "./Legend.vue?vue&type=script&lang=ts"
export * from "./Legend.vue?vue&type=script&lang=ts"

import "./Legend.vue?vue&type=style&index=0&id=fb296248&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fb296248"

export default script